import { ElementRef,ViewChild } from '@angular/core';
import { TaskManagementService } from './../../../../task/services/task-management.service';
import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DoctorService } from '../../../../doctor/services/doctor.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActuationOperation } from 'app/modules/common/enums/actuationOperation';
import { ActivatedRoute } from '@angular/router';
import { ActionCreationService } from '../services/action-creation.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { AutorOption } from 'app/modules/common/entities/autor-options';
import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import Utils from 'app/Utils';


@Component({
    selector: 'app-gestion',
    templateUrl: './gestion.component.html',
    styleUrls: ['./gestion.component.scss'],
    standalone: false
})
export class GestionComponent implements OnInit, OnChanges {

  public ActuationOperationTypes: typeof ActuationOperation = ActuationOperation;
  @Input() GestionFormGroup: UntypedFormGroup;
  @Input() LeaveInfo: any;
  @Output() TipoSend: EventEmitter<any>= new EventEmitter();
  @Input() IsOrden: any;
  @Input() companyId : any;
  @ViewChild('medicoSelect')doctorSearchInput :ElementRef
    _medicoList :any=[];
  public actuationOperation: ActuationOperation;
  DisplayPanel = false;

  public ActuationTypeList: Array<{ value: string, viewValue: string, isPermit: boolean }> = [];
  public Medico: any = [];
  public coordinatorList: any = [];
  public showType = true;
  public selectedCompany: string;
  public comentarioEmpresa : string ;
  LoggedUserMedicoId?: number;

  isInternoVisible = false;
  responsibleAuthorTypes:string;
  responsibleModuleName:string;
  isShowAutor;
  constructor(
    private doctorService: DoctorService,
    public route: ActivatedRoute,
    private actionCreationService: ActionCreationService,
    private sharedServie: SharedService,
    public taskService: TaskSaveService,
    public taskManagementService: TaskManagementService,
    private _empresaService : EmpresaService
  ) { 
    this.taskManagementService.initTaskForm(1);
  }

  ngOnChanges(): void {
    if (this.GestionFormGroup && this.LeaveInfo) {
      //this.getLoggedUserMedicoId();
      this.setFormValues();
      this.DisplayPanel = true;
      this.init();
    }
  }

  ngOnInit(): void {
    this.actuationOperation = Number(this.route.snapshot.paramMap.get('operation'));
    this.responsibleAuthorTypes="GCM";
    this.responsibleModuleName="app-gestion";
    this.isShowAutor=true;
    this.selectedCompany = localStorage.getItem("Empresa");


    if (this.actuationOperation === ActuationOperation.SolicitarAlta || this.actuationOperation === ActuationOperation.MantenerIt) {
      this.isShowAutor=false;
    }
    if(this.actuationOperation === ActuationOperation.Orden){
      this.responsibleModuleName="app-orden";
    }
   this.GetEmpresaById(this.selectedCompany)
  }

  public GetEmpresaById(companyId: any) {
    this._empresaService.GetEmpresaById(companyId).subscribe(res => {
      if (res.result) {
        this.comentarioEmpresa = res.result.comentarioParaEmpresa;
  
        if (this.actuationOperation === ActuationOperation.Comentarios) {
          this.LoadComentarioActuationTypes();
        }
      }
    });
  }

  SearchDoctors()
    {
      const searchInput=this.doctorSearchInput.nativeElement.value ?
        this.doctorSearchInput.nativeElement.value.toLowerCase():'';
  
      this._medicoList =this.Medico.filter(m=>{
        if(m.viewValue!=null)
        {
        const viewValue : string=m.viewValue.toLowerCase();
        return viewValue.indexOf(searchInput) > -1;
        }
      })
      
    }
    
  getLoggedUserMedicoId(): void {
    const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    this.LoggedUserMedicoId = currentUser.medicoId;
  }

  init(): void {
    this.configView();
    this.LoadMedico();
    this.LoadCoordinatorDropdownList();
  }

  configView(): void {
    if (this.actuationOperation === ActuationOperation.GestionConMutua) {
      this.LoadActuationTypes();
      this.GestionFormGroup.get('Gestion.Type').patchValue('31125');
      this.showType = false;
    }
    if (this.actuationOperation === ActuationOperation.InformeMedico) {
      this.showType = false;
      this.GestionFormGroup.get('Gestion.Type').patchValue('34001');
    }
    if (this.actuationOperation === ActuationOperation.DocumentoNoMedico) {
      this.showType = false;
      this.GestionFormGroup.get('Gestion.Type').patchValue('18001');
    }
    if (this.actuationOperation === ActuationOperation.SmsEntregado) {
      this.showType = false;
      this.GestionFormGroup.get('Gestion.Type').patchValue('14011');
    }
    if (this.actuationOperation === ActuationOperation.SmsNoEntregado) {
      this.showType = false;
      this.GestionFormGroup.get('Gestion.Type').patchValue('14019');
    }
    if (this.actuationOperation === ActuationOperation.SolicitarAlta) {
      this.showType = false;
      this.GestionFormGroup.get('Gestion.Type').patchValue('40001');
    }
    if (this.actuationOperation === ActuationOperation.MantenerIt) {
      this.showType = false;
      this.GestionFormGroup.get('Gestion.Type').patchValue('40002');
    }
    if (this.actuationOperation === ActuationOperation.Orden) {
      this.LoadOrdernActuationTypes();
    }
  }

  setFormValues(): void {
    const obj = this.GetGestionObject();
    this.GestionFormGroup.get('Gestion').patchValue(obj);
  }

  GetGestionObject(): any {
    const gestionObject: any = {};
    gestionObject.Type = '';

    // if (this.LoggedUserMedicoId !== null) {
    //   gestionObject.Doctor = this.LoggedUserMedicoId;
    // } else {
    //   gestionObject.Doctor = this.LeaveInfo.medicoId;
    // }


    if (this.sharedServie.getCurrentUser().coordinador !== null) {
      gestionObject.Autor = this.sharedServie.getCurrentUser().coordinador;
    }

    if (this.actuationOperation === ActuationOperation.GestionConMutua) {
      gestionObject.Inform = '';
    } else if (this.actuationOperation === ActuationOperation.InformeMedico || this.actuationOperation === ActuationOperation.DocumentoNoMedico) {
      gestionObject.Comments = '';
    }
    return gestionObject;
  }

  LoadActuationTypes(): void {
    this.ActuationTypeList = [
      { value: '31125', viewValue: 'Despacho telefónico', isPermit: true },
      { value: '30125', viewValue: 'Despacho presencial', isPermit: true }
    ];
  }

  LoadMedico(): void {
    this.doctorService.GetActiveDoctorsDropdown()
      .subscribe(res => {
        this.Medico = res;
        this._medicoList=res;
      });
  }

  LoadCoordinatorDropdownList(): void {
    this.taskService.GetActiveCoordinator().subscribe(res => {
      if (res) {
        this.coordinatorList = res.result;
      }
    });
  }

  LoadComentarioActuationTypes(): void {
    const per = this.actionCreationService.actionCreatePermissions;
    const isParaEmpresaEnabled = this.comentarioEmpresa === 'S';
    
    this.ActuationTypeList = [
      { value: '19999', viewValue: 'Administrativo', isPermit: per.HasPermit607 },
      { value: '29999', viewValue: 'Coordinación', isPermit: per.HasPermit607 },
      { value: '39999', viewValue: 'Médico', isPermit: per.HasPermit607 },
      { value: '49999', viewValue: 'De Empresa', isPermit: true },
      { value: '49901', viewValue: 'Para la Empresa', isPermit: isParaEmpresaEnabled },
      { value: '59999', viewValue: 'Mútua', isPermit: per.HasPermit607 }
    ];
  }

  LoadOrdernActuationTypes(): void {
    this.ActuationTypeList = [
      { value: '20101', viewValue: 'Visitar', isPermit: true },
      { value: '21101', viewValue: 'Contactar', isPermit: true },
      { value: '25102', viewValue: 'Actualizar FPA', isPermit: true },
      { value: '29001', viewValue: 'No visitar', isPermit: true },
    ];
  }

  toggletInterno(value: string): void {
    this.TipoSend.emit(value)
    if (value === '49901' || value === '59999') {
      this.GestionFormGroup.get(['Gestion', 'Interno']).setValue(false);
      this.isInternoVisible = false;
    } else {
      this.isInternoVisible = true;
    }

    if(value='19999')
    {}
   
  }

  public autorSelected(selectedAutor: AutorOption): void {
    // this.GestionFormGroup.get(['Gestion', 'Autor']).patchValue(selectedAutor.Autor);
    
    const employeeFormConst = this.GestionFormGroup.get(['Gestion']) as UntypedFormGroup;
    employeeFormConst.addControl("TipoAutor", new UntypedFormControl(null));

    this.GestionFormGroup.get(['Gestion', 'TipoAutor']).patchValue('C');

    // if (selectedAutor.Tipo === 'M') {
    //   this.GestionFormGroup.get(['Gestion', 'Doctor']).patchValue(selectedAutor.MedicoId);
    // } else {
    //   this.GestionFormGroup.get(['Gestion', 'Doctor']).patchValue(null);
    // }

  }

  public autorOtherSelected(): void {
    this.GestionFormGroup.get(['Gestion', 'Autor']).patchValue(null);
    this.GestionFormGroup.get(['Gestion', 'TipoAutor']).patchValue(null);
    this.GestionFormGroup.get(['Gestion', 'Doctor']).patchValue(null);
  }

}
